import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(({ colors }) => ({
    tabSelected: {
        color: colors.white,
    },
    tabWrapper: {
        alignItems: 'center',
    },
    tabRoot: {
        '@media (max-width: 767px)': {
            fontSize: '13px',
        },
        textTransform: 'none',
        fontSize: '14px',
        padding: 0,
        minWidth: 50,
    },
    tabsRoot: {
        '@media (max-width: 767px)': {
            paddingLeft: 0,
            paddingRight: 0,
        },
        borderBottom: `1px solid #ffffff4d`,
        backgroundColor: colors.dark.dark4,
        paddingLeft: '12px',
        paddingRight: '12px',
        color: '#ffffff99',
    },
    tabsIndicator: {
        height: '1px',
        backgroundColor: colors.white,
    },
}))
